import React from 'react'
import type { ColumnsRowsSettings } from '../types/columns-rows-settings'

type UseGuideSettingsApplyArgs = {
  previewSettings: ColumnsRowsSettings | null
  onSettingsChange: (settings: ColumnsRowsSettings) => void | Promise<void>
  onOpenChange: (open: boolean) => void
  setApplyError: (error: string | null) => void
  setIsApplying: (applying: boolean) => void
}

/** Apply: awaits `onSettingsChange`, closes on success, shows an error line on failure. */
export function useGuideSettingsApply({
  previewSettings,
  onSettingsChange,
  onOpenChange,
  setApplyError,
  setIsApplying,
}: UseGuideSettingsApplyArgs) {
  return React.useCallback(async () => {
    if (previewSettings == null) return

    setApplyError(null)
    setIsApplying(true)
    try {
      await onSettingsChange(previewSettings)
      onOpenChange(false)
    } catch {
      setApplyError('Failed to save guide settings')
    } finally {
      setIsApplying(false)
    }
  }, [onOpenChange, onSettingsChange, previewSettings, setApplyError, setIsApplying])
}
